import { ColDef } from '~components/dataGrids/interfaces/colDef';
import { GridColTypeEnum } from '~components/dataGrids/interfaces/gridColTypeEnum';
import { BaseReference } from '~interfaces';
import i18n from '~lib/i18n';
import { formatDateTime } from '~utils/dateUtils';

interface Organisation extends BaseReference {
	devicesCount?: number;
	keysCount?: number;
	usersCount?: number;
	creationDate: Date;
	emailAddress?: string;
	phoneNumber?: string;
}

export default Organisation;

export const organisationGridCols: Record<string, ColDef<Organisation>> = {
	devicesCount: {
		field: 'devicesCount',
		headerName: 'entities:device.labels.plural',
		gridColType: GridColTypeEnum.Regular,
		valueGetter: (value: Organisation) =>
			i18n.t('device.labels.count', {
				ns: 'entities',
				count: value.devicesCount ?? 0,
			}),
		defaultShown: true,
	},
	keysCount: {
		field: 'keysCount',
		headerName: 'entities:key.labels.plural',
		gridColType: GridColTypeEnum.Regular,
		valueGetter: (value: Organisation) =>
			i18n.t('key.labels.count', {
				ns: 'entities',
				count: value?.keysCount ?? 0,
			}),
		defaultShown: true,
	},
	usersCount: {
		field: 'usersCount',
		headerName: 'entities:user.labels.plural',
		gridColType: GridColTypeEnum.Regular,
		valueGetter: (value: Organisation) =>
			i18n.t('user.labels.count', {
				ns: 'entities',
				count: value?.usersCount ?? 0,
			}),
		defaultShown: true,
	},
	creationDate: {
		field: 'creationDate',
		headerName: 'date:createdAt',
		gridColType: GridColTypeEnum.Regular,
		valueGetter: (value: Organisation) => formatDateTime(value?.creationDate),
		defaultShown: true,
	},
};
